  <mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="onTabChanged($event)" [selectedIndex]="selectedIndex"
    (selectedIndexChange)="selectedIndexChange($event)" class="mat-tab-group">
    <mat-tab label="DETAILS">
      <ng-template matTabContent>
        <div id="main" fxLayout="column" fxLayoutAlign="start start">
          <ifc-app-scroll-container>
            <div class="content" fxLayout.gt-md="row" fxLayoutAlign.gt-md="center start" fxLayoutGap.gt-md="48px"
              fxLayout="column" fxLayoutAlign="start center" fxFlexFill.lt-lg ngClass.lt-lg="fit-content">

              <!-- Form -->
              <form [formGroup]="form">
                <div fxLayout.gt-md="row wrap" fxLayoutGap.gt-md="24px" fxLayout="column" fxLayoutAlign="start start">
                  <ifb-card>
                    <div fxLayout="column" fxLayoutAlign="start start" ngClass="width-100-perc">

                      <ifc-account-loan-number-input [fc]="form.get('loanNumber')"
                        [readonly]="data.viewMode || !transactionNew && !canEditLoan || !readWriteTransaction"
                        (autocompleteOptionSelected)="accountUpdate($event)" (clearInput)="clear('entityName', true)"
                        [disabled]="data.viewMode || !readWriteTransaction" [includedStatus]="includedStatus"
                        [excludedStatus]="excludedStatus" [excludeLoansWithNoOwnerAssigned]="true" [excludeLoansWithResolvedCase]="true">
                      </ifc-account-loan-number-input>

                      <ifc-account-business-name-input [fc]="form.get('entityName')"
                        [readonly]="data.viewMode || !transactionNew && !canEditLoan || !readWriteTransaction"
                        (autocompleteOptionSelected)="accountUpdate($event)" (clearInput)="clear('loanNumber', true)"
                        [disabled]="data.viewMode || !readWriteTransaction" [includedStatus]="includedStatus"
                        [excludedStatus]="excludedStatus" [excludeLoansWithNoOwnerAssigned]="true" [excludeLoansWithResolvedCase]="true">
                      </ifc-account-business-name-input>

                      <div class="layout margin-bottom width-100-perc" *ngIf="editingSubtransactions || data.viewMode">
                        <table class="space-between-rows width-100-perc">

                          <tr class="row-header">
                            <td class="index"></td>
                            <td class="item-title secondary-text">Transaction type</td>
                            <td class="item-title secondary-text align-right">Amount</td>
                            <td class="index"></td>
                          </tr>

                          <tr class="row" formArrayName="subtransactions"
                            *ngFor="let subtransaction of subtransactions; index as i">
                            <ng-container [formGroupName]="i">

                              <td class="index">{{i+1}}</td>

                              <td class="type-select" *ngIf="!data.viewMode">
                                <mat-form-field appearance="fill" class="mat-form-field-sm" subscriptSizing="dynamic">
                                  <mat-select placeholder="Add type" [(value)]="subtransaction.type" formControlName="subType">
                                    <mat-option [value]="type.value" *ngFor="let type of subtransactionTypeNames">
                                      {{type.name}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </td>

                              <td class="type-view" *ngIf="data.viewMode">
                                <span [ngClass]="{'mat-light-grey': !subtransaction.display}">
                                  {{formatSubtransactionType(subtransaction.type)}}
                                </span>
                              </td>

                              <td class="amount align-right" *ngIf="!data.viewMode">
                                <mat-form-field appearance="fill" class="mat-form-field-sm amount-field" subscriptSizing="dynamic">
                                  <input matInput currencyMask [options]="{align : 'right', allowNegative: true}"
                                    type="text" [(ngModel)]="subtransaction.amount" formControlName="subAmount"
                                    (blur)="accountNewBalancesInitTransaction()">
                                </mat-form-field>
                              </td>

                              <td class="align-right" *ngIf="data.viewMode">
                                <span [ngClass]="{'mat-light-grey': !subtransaction.display}">
                                  {{subtransaction.amount | currency: '$'}}
                                </span>
                              </td>

                              <td class="delete" *ngIf="!data.viewMode">
                                <button type="button" mat-icon-button class="mat-icon-button-sm" (click)="deleteRow(i)">
                                  <mat-icon class="delete-icon">delete</mat-icon>
                                </button>
                              </td>

                              <td class="index" *ngIf="data.viewMode"></td>

                            </ng-container>

                          </tr>

                          <tr class="row" *ngIf="!data.viewMode">
                            <td colspan="4">
                              <button type="button" color="primary" mat-icon-button class="mat-icon-button-sm" (click)="insertRow()">
                                <mat-icon>add_circle</mat-icon>
                              </button>
                            </td>
                          </tr>

                          <tr class="row" *ngIf="data.viewMode">
                            <td class="index"></td>
                            <td>Total</td>
                            <td class="align-right">{{transactionPrincipal.displayAmount | currency:'$'}}</td>
                            <td class="index"></td>
                          </tr>

                        </table>
                      </div>

                      <mat-form-field appearance="outline" *ngIf="!editingSubtransactions && !data.viewMode">
                        <mat-label>Amount</mat-label>
                        <input matInput [required]="!editingSubtransactions" formControlName="amount" type="text"
                          placeholder="Amount" currencyMask (blur)="accountNewBalancesInit()" autocomplete="off">
                        <mat-hint *ngIf="account && accountInfo && isTransactionTypeDraw">Enter an amount between
                          {{accountInfo.minDrawAmount | currency:'$'}} and
                          {{accountInfo.availableFunds | currency:'$'}}.</mat-hint>
                        <mat-hint *ngIf="account && accountInfo && isTransactionTypePayment">Enter an amount between
                          {{accountInfo.minPaymentAmount | currency:'$'}} and
                          {{accountInfo.currentPayoffAmount | currency:'$'}}.</mat-hint>
                        <mat-error
                          *ngIf="account && isTransactionTypeDraw && (form.get('amount').hasError('min') || form.get('amount').hasError('max'))">
                          Enter
                          an amount between {{accountInfo.minDrawAmount | currency:'$'}} and
                          {{accountInfo.availableFunds | currency:'$'}}.</mat-error>
                        <mat-error
                          *ngIf="account && isTransactionTypePayment && (form.get('amount').hasError('min') || form.get('amount').hasError('max'))">
                          Enter an amount between {{accountInfo.minPaymentAmount | currency:'$'}} and
                          {{accountInfo.currentPayoffAmount | currency:'$'}}.
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Transfer Method</mat-label>
                        <mat-select matInput formControlName="transferMethod" placeholder="Transfer Method">
                          <mat-option *ngFor="let option of transferMethods" [value]="option.value">
                            {{option.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Transfer Source</mat-label>
                        <mat-select matInput formControlName="transferSource" placeholder="Transfer Source">
                          <mat-option *ngFor="let option of transferSources" [value]="option.value">
                            {{option.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Requested By</mat-label>
                        <mat-select matInput formControlName="requestedBy">
                            <mat-option *ngFor="let option of initiatorOptions" [value]="option">
                              {{option.name}}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select matInput formControlName="status" placeholder="Status">
                          <mat-option *ngFor="let option of transactionStatusOptions" [value]="option.value">
                            {{option.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" *ngIf="form.get('status').value === TransactionStatus.OnHold">
                        <mat-label>Next Status</mat-label>
                        <mat-select matInput formControlName="nextStatus" placeholder="Next Status">
                          <mat-option *ngFor="let option of transactionNextStatusOptions" [value]="option.value">
                            {{option.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <ifb-transaction-reject-input *ngIf="showRejectReasons"
                        [fc]="form.get('reasons')"
                        [usage]="FailureReasonUsage.ResidualUnderwriting">
                      </ifb-transaction-reject-input>

                      <ifb-transaction-reject-input *ngIf="form.get('status').value === TransactionStatus.Declined"
                        [fc]="form.get('reasons')"
                        [usage]="FailureReasonUsage.NACHAResponse">
                      </ifb-transaction-reject-input>

                      <ifb-transaction-reject-input
                      *ngIf="(editingSubtransactions || transactionTypeName === TransactionTypeString.Draw) && form.get('status').value === TransactionStatus.Pending"
                      [fc]="form.get('reasons')"
                      [usage]="FailureReasonUsage.PendingReason">
                      </ifb-transaction-reject-input>

                      <ifb-competitors-select-search *ngIf="showCompetitors"
                        [disabled]="data.viewMode || (transactionNew && !editingSubtransactions) || !readWriteTransaction"
                        [required]="true"
                        [selectedCompetitorIds]="transactionPrincipal.competitors"
                        (competitorsChange)="onCompetitorsChange($event)">
                      </ifb-competitors-select-search>
                    </div>

                  </ifb-card>
                  <ifb-card *ngIf="!transactionNew || editingSubtransactions">
                    <div class="dates-container">
                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('date')"
                          [label]="'Transaction date'"
                          [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          [min]="!canSetTransactionDateInThePast ? minDate : null"
                          (blured)="clearMinDateValidationIfNotDirty(form.get('date'))"
                          (clearInput)="clear('date', false, 'time')">
                        </ifc-datepicker>

                        <mat-form-field class="form-field-custom-xs" appearance="outline">
                          <mat-label>Transaction time</mat-label>
                          <input matInput formControlName="time" type="text" placeholder="Transaction time"
                            [value]="form.get('date').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button (click)="pickTime('date', 'time')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayoutAlign="start strech" fxLayoutGap="24px" fxLayoutGap.xs=""
                        fxLayout.xs="column">
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                          <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('underwritingDate')"
                            [label]="'UW date'" [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                            (clearInput)="clear('underwritingDate', false, 'underwritingTime')">
                          </ifc-datepicker>
                        </div>

                        <mat-form-field appearance="outline" class="form-field-custom-xs">
                          <mat-label>UW time</mat-label>
                          <input matInput formControlName="underwritingTime" type="text" placeholder="UW time"
                            [value]="form.get('underwritingDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('underwritingDate', 'underwritingTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('financeDate')"
                          [label]="'Finance date'" [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          (clearInput)="clear('financeDate', false, 'financeTime')">
                        </ifc-datepicker>

                        <mat-form-field class="form-field-custom-xs" appearance="outline">
                          <mat-label>Finance time</mat-label>
                          <input matInput formControlName="financeTime" type="text" placeholder="Finance time"
                            [value]="form.get('financeDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('financeDate', 'financeTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('processDate')"
                          [label]="'Processed date'"
                          [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          (clearInput)="clear('processDate', false, 'processTime')">
                        </ifc-datepicker>

                        <mat-form-field class="form-field-custom-xs" appearance="outline">
                          <mat-label>Processed time</mat-label>
                          <input matInput formControlName="processTime" type="text" placeholder="Processed time"
                            [value]="form.get('processDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('processDate', 'processTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('completeDate')"
                          [label]="'Complete date'" [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          (clearInput)="clear('completeDate', false, 'completeTime')">
                        </ifc-datepicker>

                        <mat-form-field appearance="outline" class="form-field-custom-xs">
                          <mat-label>Complete time</mat-label>
                          <input matInput formControlName="completeTime" type="text" placeholder="Complete time"
                            [value]="form.get('completeDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('completeDate', 'completeTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('cancellationDate')"
                          [label]="'Cancellation date'"
                          [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          (clearInput)="clear('cancellationDate', false, 'cancellationTime')">
                        </ifc-datepicker>

                        <mat-form-field class="form-field-custom-xs" appearance="outline">
                          <mat-label>Cancellation time</mat-label>
                          <input matInput formControlName="cancellationTime" type="text" placeholder="Cancellation time"
                            [value]="form.get('cancellationDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('cancellationDate', 'cancellationTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="24px">
                        <ifc-datepicker class="form-field-custom-xs" [fc]="form.get('declinedDate')"
                          [label]="'Declined date'"
                          [disabled]="data.viewMode || !canEditDates || !readWriteTransaction"
                          (clearInput)="clear('declinedDate', false, 'declinedTime')">
                        </ifc-datepicker>

                        <mat-form-field class="form-field-custom-xs" appearance="outline">
                          <mat-label>Declined time</mat-label>
                          <input matInput formControlName="declinedTime" type="text" placeholder="Declined time"
                            [value]="form.get('declinedDate').value | date: 'shortTime'" readonly>
                          <button type="button" matSuffix mat-icon-button
                            (click)="pickTime('declinedDate', 'declinedTime')"
                            [disabled]="data.viewMode || disabledTimePicker || !readWriteTransaction">
                            <mat-icon>access_time</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div fxLayout="column" fxLayoutGap="0px" class="form-field-custom-xl" *ngIf="editingSubtransactions">
                        <mat-form-field appearance="outline">
                          <mat-label>Promotion</mat-label>
                          <mat-select matInput multiple formControlName="promotion" placeholder="Promotion" [(ngModel)]="selectedPromotions">
                            <mat-option *ngFor="let option of promotionsOptions" [value]="option.id">{{option.exclusivePromotion ? '*' : ''}}{{option.name}}</mat-option>
                          </mat-select>
                          <button type="button" *ngIf="form.get('promotion').value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="form.get('promotion').setValue(null)"
                            [disabled]="data.viewMode || !readPromotions">
                            <mat-icon>close</mat-icon>
                          </button>
                          <mat-hint>* Exclusive promotions cannot be combined with other promotions</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </ifb-card>

                </div>
              </form>
              <!-- End Form -->

              <div fxLayout.gt-md="{{!transactionNew || editingSubtransactions ? 'column' : 'row'}}"
                fxLayoutAlign.gt-md="start start"
                fxLayoutGap.gt-md="{{!transactionNew || editingSubtransactions ? '32px' : '48px'}}" fxLayout="column"
                fxLayoutAlign="start center">

                <!-- Transfer details -->
                <ifb-card>
                  <ifc-simple-horizontal-list-widget title="Transfer details"
                                                     [listItems]="listItems$ | async"
                                                     [config]="transferDetailsConfig">
                  </ifc-simple-horizontal-list-widget>
                </ifb-card>
                <!-- End Transfer details -->

                <!-- Draw conditions -->
                <ifb-card *ngIf="drawRequirementGroups.length">
                  <div class="draw-conditions">
                    <h3 class="draw-conditions-title">Draw conditions</h3>
                    <div *ngFor="let group of drawRequirementGroups" class="draw-conditions-group">
                      <p class="draw-conditions-group-title">{{ group.title }}</p>
                      <ul class="draw-conditions-list">
                        <li *ngFor="let item of group.items" [innerHTML]="item"></li>
                      </ul>
                    </div>
                  </div>
                </ifb-card>
                <!-- End Draw conditions -->

                <!-- Notes -->
                <ifb-card>
                  <ifb-note-card [fc]="form.get('note')" [notes]="transactionPrincipal.notes"
                    [initiator]="data.userCurrent" [ngClass.lt-lg]="'layout margin-top'">
                  </ifb-note-card>
                </ifb-card>
                <!-- End Notes -->

              </div>
            </div>
          </ifc-app-scroll-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="BANK TRANSACTIONS" *ngIf="canViewBankTransactions">
      <ng-template matTabContent>
        <ifb-transaction-bank-transactions [account]="account" [bankAccountId]="bankAccountId"
          [postedDateTo]="transactionPrincipal.underwritingDate" [active]="true"></ifb-transaction-bank-transactions>
      </ng-template>
    </mat-tab>

    <mat-tab label="AUDIT TRAIL" *ngIf="canViewAudit">
      <ng-template matTabContent>
        <ifb-transaction-audit-trail></ifb-transaction-audit-trail>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
